import { jsx, jsxs } from "react/jsx-runtime";
import "react";
const SvgGoogle = (props)=>/*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "none",
        viewBox: "0 0 21 21",
        ...props,
        children: [
            /*#__PURE__*/ jsx("g", {
                clipPath: "url(#google_svg__a)",
                children: /*#__PURE__*/ jsxs("g", {
                    clipPath: "url(#google_svg__b)",
                    children: [
                        /*#__PURE__*/ jsx("path", {
                            fill: "#4285F4",
                            d: "M20.5 11.134c0-.71-.065-1.391-.186-2.046h-9.61v3.868h5.492c-.237 1.25-.956 2.31-2.036 3.019v2.51h3.297c1.93-1.742 3.043-4.306 3.043-7.351"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            fill: "#34A853",
                            d: "M10.705 20.903c2.755 0 5.065-.895 6.753-2.422l-3.298-2.51c-.914.6-2.082.955-3.455.955-2.658 0-4.908-1.76-5.71-4.123h-3.41v2.59c1.68 3.27 5.13 5.51 9.12 5.51"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            fill: "#FBBC04",
                            d: "M4.994 12.804a5.9 5.9 0 0 1-.32-1.9c0-.66.116-1.3.32-1.9V6.411H1.585a9.84 9.84 0 0 0 0 8.983z"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            fill: "#E94235",
                            d: "M10.705 4.882c1.498 0 2.843.504 3.9 1.495l2.927-2.868C15.765 1.895 13.455.904 10.705.904c-3.99 0-7.44 2.241-9.12 5.51l3.41 2.59c.802-2.363 3.052-4.122 5.71-4.122"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "google_svg__a",
                        children: /*#__PURE__*/ jsx("path", {
                            fill: "#fff",
                            d: "M.5.904h20v20H.5z"
                        })
                    }),
                    /*#__PURE__*/ jsx("clipPath", {
                        id: "google_svg__b",
                        children: /*#__PURE__*/ jsx("path", {
                            fill: "#fff",
                            d: "M.5.904h20v20H.5z"
                        })
                    })
                ]
            })
        ]
    });
const google = SvgGoogle;
export { google as default };
